const carouselItems = [
  {
    title: '长相思 · 大荒风云',
    desc: '上古神话背景下的大荒世界，小夭与四位男主的命运纠缠，虐心与深情交织的史诗传奇。杨紫一人分饰多角，演技炸裂。',
    img: 'https://readdy.ai/api/search-image?query=epic%20Chinese%20fantasy%20drama%20with%20ancient%20palace%20and%20mystical%20landscape%2C%20beautiful%20hanfu%20costume%20characters%2C%20dramatic%20golden%20lighting%2C%20cinematic%20composition%2C%20rich%20warm%20tones&width=900&height=500&seq=crsl-kk-01&orientation=landscape',
    alt: '长相思专题推荐',
    tag: '年度热剧',
  },
  {
    title: '莲花楼 · 江湖奇案录',
    desc: '李莲花携手方多病探案江湖，十年前的惊天秘密逐渐浮出水面。武侠与推理的完美结合，每个案件都让你欲罢不能。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20mystery%2C%20lone%20swordsman%20facing%20ancient%20temple%2C%20misty%20mountain%20with%20pine%20trees%2C%20atmospheric%20fog%2C%20dramatic%20cinematic%20lighting%2C%20cool%20teal%20tones&width=900&height=500&seq=crsl-kk-02&orientation=landscape',
    alt: '莲花楼专题推荐',
    tag: '口碑爆款',
  },
  {
    title: '长风渡 · 乱世商路',
    desc: '顾九思与柳玉茹从互相看不顺眼到患难与共，乱世之中携手开创商业帝国。白敬亭宋轶二搭，化学反应拉满。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20romance%2C%20elegant%20couple%20in%20traditional%20silk%20robes%2C%20ancient%20city%20street%20background%2C%20warm%20lantern%20light%2C%20romantic%20cinematic%20mood%2C%20soft%20golden%20glow&width=900&height=500&seq=crsl-kk-03&orientation=landscape',
    alt: '长风渡专题推荐',
    tag: '完结热剧',
  },
  {
    title: '七时吉祥 · 七世情缘',
    desc: '祥云仙子与初空神君七世轮回的爱恨纠葛，甜虐交织的仙侠爱情。杨超越丁禹兮CP感十足，服化道精美绝伦。',
    img: 'https://readdy.ai/api/search-image?query=xianxia%20romance%20drama%2C%20celestial%20beings%20in%20flowing%20colorful%20robes%2C%20heavenly%20palace%20among%20clouds%2C%20ethereal%20pastel%20lighting%2C%20dreamy%20fantasy%20atmosphere&width=900&height=500&seq=crsl-kk-04&orientation=landscape',
    alt: '七时吉祥专题推荐',
    tag: '新剧上线',
  },
  {
    title: '玉骨遥 · 空桑史诗',
    desc: '时影与朱颜跨越种族与宿命的爱恋，空桑王朝的兴衰史诗。肖战白衣仙气飘飘，4K修复版画质惊艳回归。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20epic%2C%20mystical%20warrior%20in%20white%20robes%20standing%20on%20cliff%20overlooking%20ancient%20kingdom%2C%20dramatic%20sunset%20sky%2C%20cinematic%20wide%20shot%2C%20epic%20scale&width=900&height=500&seq=crsl-kk-05&orientation=landscape',
    alt: '玉骨遥专题推荐',
    tag: '4K修复',
  },
  {
    title: '偷偷藏不住 · 暗恋成真',
    desc: '桑稚从13岁开始的漫长暗恋，到大学时与段嘉许重逢。赵露思陈哲远演绎最甜青春恋曲，少女心爆炸。',
    img: 'https://readdy.ai/api/search-image?query=youth%20romance%20campus%20drama%2C%20young%20couple%20under%20cherry%20blossom%20trees%2C%20spring%20sunlight%2C%20warm%20pastel%20colors%2C%20sweet%20romantic%20atmosphere%2C%20soft%20focus&width=900&height=500&seq=crsl-kk-06&orientation=landscape',
    alt: '偷偷藏不住专题推荐',
    tag: '甜宠必看',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          焦点推荐
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          本周最值得关注的热门剧集
        </p>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-semibold bg-background-950/70 text-background-50 backdrop-blur-sm whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900">{item.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}